var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('import-logs-table',{attrs:{"import-id":_vm.importId,"data-scope":("$import_" + _vm.importId)}})}
var staticRenderFns = []

export { render, staticRenderFns }